import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import RegistrationForms from './RegistrationForms';

const RegistrationPage = (props) => {

    return (
        <Fragment>
            <Header hclass={'header--styleFour'}/>
            <main className="main">
                <PageTitle pageTitle={'Register now'} pagesub={'register'}/>
                <RegistrationForms/> 
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default RegistrationPage;